import { Link } from 'react-router-dom';
import { getFeaturedArticle, getHotArticles, buildArticlePath, formatViews } from '@/utils/articles';

export default function HeroSection() {
  const featured = getFeaturedArticle();
  const hotList = getHotArticles(6);

  return (
    <section className="mx-auto max-w-[1280px] px-4 pt-6 md:px-6 md:pt-8" aria-label="今日焦点">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        <Link
          to={buildArticlePath(featured.id)}
          className="group relative col-span-1 h-[380px] overflow-hidden rounded-2xl md:h-[460px] lg:col-span-2 lg:h-[520px]"
        >
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20dramatic%20entertainment%20news%20hero%20scene%20with%20warm%20crimson%20spotlights%20and%20golden%20confetti%20bokeh%2C%20cinematic%20magazine%20cover%20style%2C%20dark%20elegant%20background%20contrasting%20bright%20light%2C%20no%20text%2C%20no%20identifiable%20faces%2C%20high%20detail%2C%20luminous%20atmosphere&width=1200&height=800&seq=hero-18baoliao-main&orientation=landscape"
            alt="今日焦点爆料主视觉"
            title="18爆料网今日焦点"
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" />
          <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-5 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-fire-fill" />
                今日焦点
              </span>
              <span className="rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                {featured.categoryName}
              </span>
            </div>
            <h1 className="max-w-2xl font-heading text-2xl font-bold leading-tight text-white md:text-4xl">
              {featured.title}
            </h1>
            <p className="max-w-2xl line-clamp-2 text-sm leading-relaxed text-white/80 md:text-base">
              {featured.summary}
            </p>
            <div className="flex flex-wrap items-center gap-4 text-xs text-white/70 md:text-sm">
              <span>{featured.author}</span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line" />
                {formatViews(featured.views)} 阅读
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-chat-3-line" />
                {featured.comments} 讨论
              </span>
            </div>
          </div>
        </Link>

        <aside
          id="hot"
          className="col-span-1 flex flex-col rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6"
          aria-label="今日热榜"
        >
          <div className="flex items-center justify-between">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-sm text-background-50">
                <i className="ri-fire-fill" />
              </span>
              今日热榜
            </h2>
            <span className="text-xs text-foreground-500">实时更新</span>
          </div>

          <ol className="mt-4 flex flex-1 flex-col justify-between divide-y divide-background-200">
            {hotList.map((item, index) => (
              <li key={item.id}>
                <Link to={buildArticlePath(item.id)} className="group flex items-center gap-3 py-3">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                      index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-300 text-foreground-700'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="line-clamp-2 flex-1 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </span>
                </Link>
              </li>
            ))}
          </ol>

          <div className="mt-4 flex items-center justify-between rounded-lg bg-background-50 px-4 py-3">
            <span className="text-xs text-foreground-600">今日已更新</span>
            <span className="font-heading text-lg font-bold text-primary-600">28 条</span>
          </div>
        </aside>
      </div>
    </section>
  );
}